/*!
 * jQuery Extensions Library.
 *
 * Copyright (C) HaiKom AB 2007-2014
 */
Sys.WebForms.PageRequestManager.getInstance().add_pageLoaded(function () {
	'use strict';
	$(document).ready(function () {
		var plugins = $('[data-zf-plugin]');
		if (plugins && plugins.length > 0) {
			console.log(plugins);
			$.initFoundationPlugins(plugins);
		}

		var showCookieInfoBody = $('body[data-show-cookie-info]');
		if (showCookieInfoBody.exists()) {
			var base = $('#base');
			if (base.exists()) {
				var options = showCookieInfoBody.data('show-cookie-info');

				base.showCookieInformation(options);
			}
		}

		$('[data-template-quantity-selection]').each(function () {
			var self = $(this);
			var options = self.data('template-quantity-selection');

			self.templateQuantitySelection(options);
		});

		$('[data-template-quantity-selection-listener]').each(function () {
			var self = $(this);
			var options = self.data('template-quantity-selection-listener');

			self.templateQuantitySelectionListener(options);
		});

		$('[data-color-picker]').each(function () {
			var self = $(this);

			var defaultOptions = {
				allowEmpty: true,
				clickoutFiresChange: true,
				maxSelectionSize: 50,
				palette: [],
				preferredFormat: "hex3",
				showButtons: false,
				showInitial: true,
				showInput: true,
				showPalette: true,
			};

			if (typeof self.spectrum === 'function') {
				var options = self.data('color-picker');

				options = $.extend(defaultOptions, options);

				self.spectrum(options);
			} else {
				console.warn('Spectrum plugin does not exist or had not been loaded!');
			}
		});

		$('[data-toggler]').each(function (e) {
			var self = $(this);
			var options = self.data('toggler');
			var targets = [];

			var tempTargets = null;
			if (typeof options === 'string') {
				tempTargets = options;
				options = {};
			} else if (typeof options === 'object') {
				if (options.target) {
					tempTargets = options.target;
				} else if (options.targets) {
					tempTargets = options.targets;
				}
			}

			if (tempTargets) {
				if (typeof tempTargets === 'string') {
					tempTargets = tempTargets.split(/[\s,]+/);
				}
				targets = tempTargets;
			}

			targets.forEach(function (target) {
				if (typeof target === 'string') {
					if (target[0] !== '#') {
						target = '#' + target;
					}
					target = $(target);
				}

				if (target.exists()) {
					options.target = target.selector;

					self.toggler(target, options);
				}
			});
		});

		// Mouse click
		$('[data-open-close-toggler]').off('click').click(function (e) {
			handleToggle(e, $(this));
		});

		// Enter key
		$(document).on('keydown', function (e) {
			// Ange vilken tangent som ska trigga togglingen, exempelvis Enter (keyCode 13)
			if (e.key === 'Enter') {
				var focusedElement = $(document.activeElement);

				if (focusedElement.is('[data-open-close-toggler]')) {
					handleToggle(e, focusedElement);
				}
			}
		});

		// Toggle fly-out menu
		function handleToggle(e, toggler) {
			var targetId = toggler.attr('data-open-close-toggler').trim();

			if (!targetId) {
				console.warn('No target ID specified for the CSS toggler!');
				return;
			} else if (targetId[0] !== '#') {
				targetId = '#' + targetId;
			}

			var defaultOptions = {
				toggleGroup: '',
				triggerOutsideTarget: false
			};
			var options = toggler.data('open-close-toggler-options');

			options = $.extend(defaultOptions, options);

			var target = $(targetId);
			if (target) {
				var toggleGroupPropKey = options.toggleGroup ? 'hk-open-close-toggler-otg-' + options.toggleGroup : '';
				var isVisible = target.is(':visible');

				if (isVisible) {
					if (toggleGroupPropKey) {
						$(document).prop(toggleGroupPropKey, '');
					}

					target.hide();
				} else {
					if (toggleGroupPropKey) {
						var openToggleGroupTargetId = $(document).prop(toggleGroupPropKey);
						if (openToggleGroupTargetId) {
							$(openToggleGroupTargetId).hide();
						}

						$(document).prop(toggleGroupPropKey, targetId);
					}

					target.show();
				}

				e.preventDefault();
				e.stopPropagation();

				if (options.triggerOutsideTarget) {
					$(document).click(function (evt) {
						var clickTarget = $(evt.target);

						if (!clickTarget.is(target) &&
							!target.find(clickTarget).length) {
							$(target).hide();

							$(document).off(evt);
						}

						evt.stopPropagation();
					});
				}
			}
		}

		//$('[data-open-close-toggler]').off('click').click(function (e) {
		//	var toggler = $(this);
		//	var targetId = toggler.attr('data-open-close-toggler').trim();

		//	if (!targetId) {
		//		console.warn('No target ID specified for the CSS toggler!');
		//		return;
		//	} else if (targetId[0] !== '#') {
		//		targetId = '#' + targetId;
		//	}

		//	var defaultOptions = {
		//		toggleGroup: '',
		//		triggerOutsideTarget: false
		//	};
		//	var options = toggler.data('open-close-toggler-options');

		//	options = $.extend(defaultOptions, options);

		//	var target = $(targetId);
		//	if (target) {
		//		var toggleGroupPropKey = options.toggleGroup ? 'hk-open-close-toggler-otg-' + options.toggleGroup : '';
		//		var isVisible = target.is(':visible');

		//		if (isVisible) {
		//			if (toggleGroupPropKey) {
		//				$(document).prop(toggleGroupPropKey, '');
		//			}

		//			target.hide();
		//		} else {
		//			if (toggleGroupPropKey) {
		//				var openToggleGroupTargetId = $(document).prop(toggleGroupPropKey);
		//				if (openToggleGroupTargetId) {
		//					$(openToggleGroupTargetId).hide();
		//				}

		//				$(document).prop(toggleGroupPropKey, targetId);
		//			}

		//			target.show();
		//		}

		//		e.preventDefault();
		//		e.stopPropagation();

		//		if (options.triggerOutsideTarget) {
		//			$(document).click(function (evt) {
		//				var clickTarget = $(evt.target);

		//				if (!clickTarget.is(target) &&
		//					!target.find(clickTarget).length) {
		//					$(target).hide();

		//					$(document).off(evt);
		//				}

		//				evt.stopPropagation();
		//			});
		//		}
		//	}
		//});

		// Handles maximum lines limiter in textarea elements.
		$('textarea[data-maximum-lines]').keydown(function (e) {
			var maximumLines = parseInt($(this).data('maximum-lines'), 10);
			if (e.keyCode === 13 &&
				$(this).val().split(/\r\n|\r|\n/).length >= maximumLines) {
				return false;
			}
		});

		// Handles flexible hight in textarea elements.
		$('textarea[data-flex-height]').each(function () {
			var self = $(this);
			var options = self.data('flex-height');

			self.flexHeight(options);
		});

		// Handles confirmations for elements with a data-confirm attribute
		$('[data-confirm]').off('click').click(function (e) {
			var target = $(this);
			var preventDefault = false;

			if (!target.prop('disabled') &&
				!target.hasClass('aspNetDisabled')) {

				var message = target.attr('data-confirm');
				if (message !== '') {
					if (!confirm(message)) {
						preventDefault = true;
					}
				} else {
					console.warn('The data-confirm message of target ' + target.id + ' is empty');
					preventDefault = true;
				}
			}

			if (preventDefault) {
				e.preventDefault();
			}
		});

		$('[data-click-effect-id]').off('click').click(function (e) {
			var self = $(this),
				targetId = self.attr('data-click-effect-id');
			if ($.exists('#' + targetId)) {
				var target = $('#' + targetId),
					effect = target.attr('data-click-effect'),
					callbackMethod = target.attr('data-click-effect-callback'),
					effectTokens = effect.split(':'),
					method = effectTokens[0];
				if (target[method]) {
					var duration = parseInt(effectTokens[1], 10);
					if (isNaN(duration) || duration <= 0) {
						duration = 250;
					}
					target[method](duration);
				}
				if (callbackMethod &&
					window[callbackMethod]) {
					window[callbackMethod](self);
				}
			}
			e.preventDefault();
		});

		// Handles popup links
		$('a[data-popup], a[rel*=external]').click(function (e) {
			var target = $(this),
				url = target.attr('href');
			if (url !== '') {
				$.openPopup(url);
			} else {
				console.warn('The URL of target ' + target.id + ' is empty');
			}
			e.preventDefault();
		});

		$('[data-semi-transparent-search-box]').each(function () {
			var searchBox = $(this);
			var textBox = $('[type=text]', searchBox);
			var button = $('.button', searchBox);

			var _focus = function () {
				searchBox.css('opacity', 1);
			};
			var _blur = function () {
				var text = $('[type=text]', searchBox).val().trim();
				if (text === '') {
					searchBox.css('opacity', 0.8);
				}
			};

			$('[type=text], .button', searchBox).focus(function () {
				_focus();
			}).blur(function () {
				_blur();
			});

			_blur();
		});

		// Handles placeholders (watermarks) for browser that does not support the placeholder attribute
		if (!('placeholder' in document.createElement('input'))) {
			var _addWatermark = function (input) {
				if (typeof input !== 'undefined' && input.val() === '') {
					var watermark = $(this).attr('placeholder');
					if (typeof watermark !== 'undefined' && watermark !== '') {
						input.val(watermark)
							.attr('data-watermarked', 'watermarked')
							.addClass('watermark');
					}
				}
			};
			var _removeWatermark = function (input) {
				if (typeof input !== 'undefined' && input.attr('data-watermarked') === 'watermarked') {
					var watermark = input.attr('placeholder');
					if (input.val() === watermark) {
						input.val('')
							.removeAttr('data-watermarked')
							.removeClass('watermark');
					}
				}
			};

			$('input[placeholder]').focus(function () {
				_removeWatermark($(this));
			}).blur(function () {
				_addWatermark($(this));
			}).each(function () {
				_addWatermark($(this));
			});
		}

		$('button:not([type])').each(function(){
			$(this).attr('type', 'button');
		});

		// Prevent blocking submit from drop-down lists
		$('select').change(function () {
			Page_BlockSubmit = false;
		});
	});
});
